import React, { Component } from 'react'

import config from 'config'
import request from '@/modules/base/util/request'
import ModalBig from '../big/modal-big'
import styles from './avv-modal.css'
import Loader from '../../loader/loader'
import { ButtonSquare } from '../../buttons'

const { resourceHost } = config
const AVV_REQUEST_URL = `${resourceHost}auth/buhlkonto/avv/text`

class AvvModal extends Component {
  constructor(props) {
    super(props)

    const { src } = props

    this.state = {
      avvText: null,
      sourceUrl: src || AVV_REQUEST_URL,
    }
  }

  componentDidMount() {
    this.setState({ isLoading: true }, () => {
      const { sourceUrl } = this.state
      return request(sourceUrl, {
        auth: true,
        isConcurrent: true,
        json: false,
        headers: { Accept: 'text/html' },
      })
        .then(request => {
          this.setState({ avvText: request.body, isLoading: false })
        })
        .catch(error => {
          console.error(error)
        })
    })
  }

  render() {
    const { avvText, isLoading } = this.state
    const { open, onClose } = this.props

    const actions = [
      <ButtonSquare key="btn-close" label='Schließen' onClick={onClose} />,
    ]
    const content = isLoading
      ? (
        <Loader visible={isLoading} />
      )
      : (
        <div className={styles.container}>
          <p className={styles.content} dangerouslySetInnerHTML={{ __html: avvText }} />
        </div>
      )

    return (
      <ModalBig dataQsId='avvModal' dialogContentClass={styles.dialogContent} open={open} actions={actions} onClose={onClose}>
        {content}
      </ModalBig>
    )
  }
}

export default AvvModal
